(() => {
  const tier3Items = document.querySelectorAll('.js-sub-nav-item');
  const tier2Details = document.querySelectorAll('.js-main-nav-level');
  const tier3Details = document.querySelectorAll('.js-sub-nav-item');
  const announcement = document.querySelector('.announcement-wrapper');
  const menuDrawer = document.querySelector('#menu-drawer');
  
  const isMobileView = () => window.innerWidth <= 750;

  const updateMenuDrawerPosition = () => {
    if (!announcement || !menuDrawer) return;
    const isAnnouncementVisible = !announcement.classList.contains('announcement-wrapper--hidden');
    menuDrawer.style.top = isAnnouncementVisible ? '-33px' : '0px';
  };

  const adjustMenuDrawerHeight = () => {
    if (!menuDrawer) return;
    const viewportHeight = window.innerHeight;
    menuDrawer.style.height = `${viewportHeight}px`;
  };


  const handleTier3Toggle = (event) => {
    if (!isMobileView()) return;

    const item = event.currentTarget;
    const menuDrawerMenu = item.querySelector('.menu-drawer__menu');
    const arrow = item.querySelector('.js-svg-wrapper svg');
    
    if (!item.classList.contains('js-sub-nav-item') || !item.classList.contains('menu-opening')) {
      return;
    }

    const target = event.target.closest('a.sub-nav-link');
    if (target && (target.getAttribute('href') === '#' || !target.getAttribute('href'))) {
      event.preventDefault();
      return;
    }
    
    if (!menuDrawerMenu) return;
  };

  const handleTier2Toggle = (tier2) => {
    if (tier2.open) {
      tier2Details.forEach((otherTier2) => {
        if (otherTier2 !== tier2) {
          otherTier2.open = false;
        }
      });
    }
  };

  const handleTier3ExclusiveToggle = (tier3) => {
    if (tier3.open) {
      tier3Details.forEach((otherTier3) => {
        if (otherTier3 !== tier3) {
          otherTier3.open = false;
        }
      });
    }
  };

  document.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
    button.addEventListener('click', () => {
      tier3Details.forEach((tier3) => {
        tier3.open = false; 
      });
    });
  });

  tier3Items.forEach((item) => {
    item.addEventListener('click', handleTier3Toggle);
    item.addEventListener('touchstart', handleTier3Toggle); 
  });

  tier2Details.forEach((tier2) => {
    tier2.addEventListener('toggle', () => handleTier2Toggle(tier2));
  });

  tier3Details.forEach((tier3) => {
    tier3.addEventListener('toggle', () => handleTier3ExclusiveToggle(tier3));
  });
  
  document.querySelectorAll('.sub-nav-link').forEach(link => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (href === '#' || !href) {
        event.preventDefault();
        event.stopPropagation(); 
      }
    });
  });
  document.addEventListener('scroll', updateMenuDrawerPosition);
  window.addEventListener('resize', adjustMenuDrawerHeight);

  updateMenuDrawerPosition();
  adjustMenuDrawerHeight();
})();